import _ from 'lodash';
import React from 'react';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as importCsvSettings from './importCsvSettings';
import * as types from './types';



const ImportCsvModalComponent = ImportCsvModal.genComponent<types.NetSuiteInventoryLocationsPropertyName>();

export interface IProps {
  onCancel: () => void;
  onAccept: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [importNetSuiteInventoryLocations, importNetSuiteInventoryLocationsTuple] = dataService.useImportNetSuiteInventoryLocations();

  const processImport = React.useCallback(
    async (rows: Array<_.Dictionary<string>>) => {
      importNetSuiteInventoryLocations(rows);
    },
    [importNetSuiteInventoryLocations]
  );

  const loading = importNetSuiteInventoryLocationsTuple.loading;

  return (
    <ImportCsvModalComponent
      isOpen
      isLoading={loading}
      title="Import Net Suite Inventory Locations"
      columnDescriptions={importCsvSettings.columnDefs}
      formatType2Comment={importCsvSettings.propertyName2Comment}
      formatType2Data={importCsvSettings.propertyName2Data}
      fnImport={processImport}
      onCancel={props.onCancel}
      onAccept={props.onAccept} />
  );
};
